module.exports = __webpack_public_path__ + "7929d08b27cc41b833aa9e16ce9f10a0.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/gamerules/rules_fr.pdf
// module id = 411
// module chunks = 1